import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { MissionService } from "../api";
import { toast } from "react-toastify";

export const actionGetInfoMission = createAsyncThunk(
  "wallet/mission",
  async () => {
    try {
      const res = await MissionService.doGetInfoMission();
      if (res.status === 200) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return message;
      // return error.response;
    }
  }
);

export const actionGetListConstant = createAsyncThunk(
  "checkWallet/list-constant",
  async () => {
    try {
      const res = await MissionService.doGetListConstant();
      if (res.status === 200) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return message;
      // return error.response;
    }
  }
);

const missionSlice = createSlice({
  name: "mission",
  initialState: {
    infoMission: {
      loading: false,
      data: null,
      error: "",
    },
    listConstant: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // info Mission
      .addCase(actionGetInfoMission.pending, (state, action) => {
        state.infoMission.loading = true;
      })
      .addCase(actionGetInfoMission.rejected, (state, action) => {
        state.infoMission.loading = false;
        state.infoMission.error = action.payload;
        state.infoMission.data = {};
      })
      .addCase(actionGetInfoMission.fulfilled, (state, action) => {
        state.infoMission.loading = false;
        state.infoMission.data = action.payload;
        state.infoMission.error = "";
      })
      // info Mission
      .addCase(actionGetListConstant.pending, (state, action) => {
        state.listConstant.loading = true;
      })
      .addCase(actionGetListConstant.rejected, (state, action) => {
        state.listConstant.loading = false;
        state.listConstant.error = action.payload;
        state.listConstant.data = {};
      })
      .addCase(actionGetListConstant.fulfilled, (state, action) => {
        state.listConstant.loading = false;
        state.listConstant.data = action.payload;
        state.listConstant.error = "";
      });
  },
});

export default missionSlice.reducer;
export const { actions, reducer } = missionSlice;
